// Animation Moon - Modeling
uniform float uPositionFrequency;
uniform float uStrength;

attribute vec4 tangent;
varying vec2 vUv;
varying float vWobble;

float amplitude = 0.9;

#include ../includes/simplexNoise4d.glsl

float getWobble(vec3 position){

    vec3 warpedPosition = position;
    warpedPosition += simplexNoise4d(vec4(
        position,
        0.0
    ));

    return simplexNoise4d(vec4(
        warpedPosition * uPositionFrequency,
        0.0
    )) * uStrength;
}

void main()
{
    vec3 biTangent = cross(normal, tangent.xyz);
    
    float shift = 0.01;
    vec3 positionA =  csm_Position + tangent.xyz * shift;
    vec3 positionB =  csm_Position + biTangent * shift;

    
    float wobble = getWobble(csm_Position);
    csm_Position += wobble * normal;
    positionA += getWobble(positionA) * normal;
    positionB += getWobble(positionB) * normal;
    

    // compute normals
    vec3 toA = normalize(positionA - csm_Position);
    vec3 toB = normalize(positionB - csm_Position);

    csm_Normal = cross(toA, toB);
    // Varyings
    vUv = uv;
    vWobble = wobble / uStrength;
}